export default __webpack_public_path__ + "static/media/mapa.8298ebca.JPG";